module.exports = __webpack_public_path__ + "81e970b03bc0c60b2706184a497e2885.png";